import React, {useState} from 'react';
import '../NotFoundPage/Styles.css';
import { Link } from 'react-router-dom';  // Import Link from react-router-dom
import useTitle from '../../useTitle';

const NotFound = () => {
    useTitle("Oops! This page does not exist")
    // eslint-disable-next-line no-unused-vars
    const [isOpen, setIsOpen] = useState(false);
        
    // Close the navbar when a link is clicked
    const handleLinkClick = (url) => {
        setIsOpen(false); // Close the navbar
        window.location.href = url; // Force navigation to the specific URL
    };
  return (
    <>
      <div className='notFoundPageContainer'>
        <div className='notFoundPageTitleContactContainer'>
          <h1 className='notFoundPageTitle'>Error 404 - Not Found!</h1>
          <p className='notFoundText'>Oops! The page you’re looking for doesn’t exist or has been moved.</p>
          <p className='notFoundText'>Check the URL or return to our homepage.</p>
        </div>
        <div className="notFoundHomeButtonContainer">
            <Link onClick={() => handleLinkClick('/')} className="homebutton">GO BACK TO THE HOMEPAGE</Link>
        </div>
      </div>

    </>
  )
}

export default NotFound;
